import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/node_modules/@mui/material/esm/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/node_modules/@mui/material/esm/CssBaseline/CssBaseline.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/node_modules/@mui/material/esm/Typography/Typography.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/github/workspace/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/github/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/github/workspace/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/app/components/FadeIn.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/app/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/app/components/WaveDivider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/github/workspace/src/app/ShootingStarBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeRegistry"] */ "/github/workspace/src/providers/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/github/workspace/src/styles/globals.css");
